import React from "react";
import Footer from "../../../components/Footer";

const Technology = () => {
  return (
    <section className="bg-white pt-20">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* LEFT CONTENT */}
        <div className="px-6 sm:px-10 lg:px-16 py-12 lg:flex lg:items-center">
          <div>
            <p className="text-sm font-semibold text-gray-600 mb-3">
              Industries →
            </p>

            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Cyber Security for Technology Companies
            </h1>

            <p className="font-semibold text-gray-800 mb-6">
              Technology companies face intensifying cyber threats in a
              trust-driven market, where breaches can erode customer confidence
              and competitive advantage amid growing demand for secure SaaS,
              cloud, and AI-driven innovation.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              High-profile supply chain compromises and insider threats target
              intellectual property, customer data, and development pipelines,
              amplified by shadow IT, rapid tool sprawl, and remote work
              visibility gaps.
            </p>

            <p className="text-gray-600 mb-5 leading-relaxed">
              Modern technology firms operate across complex multi-cloud
              environments, APIs, and third-party integrations—creating expanded
              attack surfaces that require strong governance and continuous
              monitoring.
            </p>

            <p className="text-gray-600 mb-8 leading-relaxed">
              At the same time, organizations must meet compliance requirements
              such as SOC 2, GDPR, and emerging AI security mandates while
              managing overstretched security teams and evolving threats.
            </p>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              How can Synthera help?
            </h3>

            <ul className="space-y-4 mb-8">
              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  We secure cloud, SaaS, and application environments using Zero
                  Trust principles to protect data, users, and services across
                  distributed technology ecosystems.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  We strengthen identity, access, and API security across users,
                  systems, and integrations to reduce exposure and prevent
                  unauthorized access.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  We improve visibility into data usage, access patterns, and
                  risk exposure—helping organizations detect threats early and
                  respond quickly.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  We reduce breach impact through advanced detection, response,
                  and resilience strategies that keep innovation moving forward.
                </p>
              </li>

              <li className="flex gap-3">
                <span className="mt-2 h-2 w-2 bg-green-600 rounded-full"></span>
                <p className="text-gray-600">
                  We enable compliance readiness and strong governance without
                  slowing innovation or product development.
                </p>
              </li>
            </ul>

            <p className="text-gray-700 font-semibold mb-8">
              Synthera helps technology companies embed security as a growth
              enabler—not a blocker—so innovation, trust, and resilience grow
              together.
            </p>

            {/* COOL LINK CTA */}
            <a
              href="/Contact"
              className="group inline-flex items-center gap-1 font-semibold text-green-700 hover:text-green-800 transition"
            >
              <span className="relative">
                Talk to an expert
                <span className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-green-700 transition-all duration-300 group-hover:w-full"></span>
              </span>
              <span className="transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative hidden lg:block pt-10">
          <img
            src="https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1770613375/Technology_d5tld2.png"
            alt="Technology Cyber Security"
            className="w-full h-full object-cover"
          />

          {/* GREEN OVERLAY (MATCHED WITH IMAGE OFFSET) */}
          {/* <div className="absolute top-10 left-0 right-0 bottom-0 bg-green-900/70"></div> */}
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default Technology;
